import { jsxs as t, jsx as e } from "react/jsx-runtime";
import i from "./index.es2448.js";
import { DEFAULT_METRIC_ICON_SIZE as n } from "./index.es2447.js";
function s({
  size: C = n,
  animated: r = !1
}) {
  return /* @__PURE__ */ t(
    "svg",
    {
      width: C,
      height: C,
      viewBox: "0 0 56 56",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      className: r ? i.animated : "",
      children: [
        /* @__PURE__ */ e("rect", { width: "56", height: "56", rx: "3", fill: "#F3F3FD" }),
        /* @__PURE__ */ e(
          "path",
          {
            d: "M41 28C41 35.1797 35.1797 41 28 41C20.8203 41 15 35.1797 15 28C15 20.8203 20.8203 15 28 15C35.1797 15 41 20.8203 41 28ZM17.99 28C17.99 33.5284 22.4716 38.01 28 38.01C33.5284 38.01 38.01 33.5284 38.01 28C38.01 22.4716 33.5284 17.99 28 17.99C22.4716 17.99 17.99 22.4716 17.99 28Z",
            shapeRendering: "geometricPrecision",
            fill: "#E1E2FF"
          }
        ),
        /* @__PURE__ */ e(
          "path",
          {
            className: i.whiteQuadrant,
            d: "M41 28C41 26.2928 40.6637 24.6023 40.0104 23.0251C39.3571 21.4479 38.3995 20.0148 37.1924 18.8076C35.9852 17.6004 34.5521 16.6429 32.9749 15.9896C31.3976 15.3363 29.7072 15 28 15V17.99C29.3145 17.99 30.6162 18.2489 31.8307 18.752C33.0451 19.255 34.1486 19.9923 35.0781 20.9219C36.0077 21.8514 36.745 22.9549 37.248 24.1693C37.7511 25.3838 38.01 26.6855 38.01 28H41Z",
            shapeRendering: "geometricPrecision",
            fill: "white"
          }
        ),
        /* @__PURE__ */ e(
          "path",
          {
            className: i.primaryCircle,
            d: "M28 16.4634C25.7255 16.4634 23.5021 17.1378 21.6109 18.4015C19.7198 19.6651 18.2458 21.4612 17.3754 23.5625C16.505 25.6639 16.2772 27.9761 16.721 30.2069C17.1647 32.4377 18.26 34.4868 19.8683 36.0951C21.4766 37.7034 23.5257 38.7987 25.7565 39.2424C27.9872 39.6861 30.2995 39.4584 32.4009 38.588C34.5022 37.7176 36.2983 36.2436 37.5619 34.3524C38.8255 32.4613 39.5 30.2379 39.5 27.9634H38.005C38.005 29.9422 37.4182 31.8765 36.3189 33.5219C35.2195 35.1672 33.6569 36.4495 31.8287 37.2068C30.0006 37.964 27.9889 38.1622 26.0481 37.7761C24.1073 37.3901 22.3246 36.4372 20.9254 35.038C19.5262 33.6388 18.5733 31.856 18.1872 29.9153C17.8012 27.9745 17.9993 25.9628 18.7566 24.1346C19.5138 22.3065 20.7962 20.7439 22.4415 19.6445C24.0868 18.5452 26.0212 17.9584 28 17.9584V16.4634Z",
            shapeRendering: "geometricPrecision",
            fill: "#5E63E5"
          }
        )
      ]
    }
  );
}
s.__tags = ["load", "circle", "spinning"];
export {
  s as MetricLoadingIcon
};
//# sourceMappingURL=index.es434.js.map
